module.exports = __webpack_public_path__ + "static/media/2025Benefithilight_CSNP.8c2ffc80.pdf";